(function () {
  const COLOR_LABEL = /colou?r|colore/i;

  function getSelectedColor() {
    const picker = document.querySelector('variant-selects, variant-radios');
    if (!picker) return null;
    let color = null;

    // Varianti a pulsanti (pills/radio)
    picker.querySelectorAll('fieldset').forEach((fs) => {
      const legend = fs.querySelector('legend');
      if (legend && COLOR_LABEL.test(legend.textContent)) {
        const checked = fs.querySelector('input:checked');
        if (checked) color = checked.value;
      }
    });

    // Varianti a tendina
    if (!color) {
      picker.querySelectorAll('select').forEach((sel) => {
        const wrapper = sel.closest('.product-form__input');
        const label = wrapper && wrapper.querySelector('.form__label, label');
        if (label && COLOR_LABEL.test(label.textContent)) color = sel.value;
      });
    }
    return color ? color.toLowerCase().trim() : null;
  }

  function filterMedia() {
    const color = getSelectedColor();
    if (!color) return;

    const items = document.querySelectorAll('[thumbnail-color]');
    if (!items.length) return;

    // Se nessun alt corrisponde al colore, non nascondere nulla (failsafe)
    const anyMatch = Array.from(items).some((el) =>
      (el.getAttribute('thumbnail-color') || '').toLowerCase().includes(color)
    );
    if (!anyMatch) return;

    let firstVisibleMain = null;
    items.forEach((el) => {
      const match = (el.getAttribute('thumbnail-color') || '').toLowerCase().includes(color);
      el.style.display = match ? '' : 'none';
      if (match && !firstVisibleMain && el.classList.contains('product__media-item')) {
        firstVisibleMain = el;
      }
    });

    // Se la slide attiva è stata nascosta, attiva la prima visibile del colore
    const gallery = document.querySelector('media-gallery');
    const active = document.querySelector('.product__media-item.is-active');
    if (gallery && firstVisibleMain && (!active || active.style.display === 'none')) {
      gallery.setActiveMedia(firstVisibleMain.dataset.mediaId, true);
    }
  }

  document.addEventListener('DOMContentLoaded', filterMedia);

  // Ri-applica dopo il cambio variante (il tema aggiorna la galleria via fetch)
  document.addEventListener('change', (e) => {
    if (e.target.closest('variant-selects, variant-radios')) {
      setTimeout(filterMedia, 300);
      setTimeout(filterMedia, 900); // fallback se la risposta è lenta
    }
  });
})();